import { useState } from "react";
import { useCoachAuthContext  } from "./useCoachAuthContext";
import API_URL from '../../api/API';
import { Link,useNavigate } from "react-router-dom";



export const useCoachLogin = () =>{

    const navigate = useNavigate();

    const [error,setError] = useState(null);
    const [isLoading,setIsLoading] = useState(null);
    const {dispatch} = useCoachAuthContext();

    const coachLogin = async (email,password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_COACH_LOGIN,{
                method: 'POST',
                headers: {'Content-Type' : 'application/json'},
                body: JSON.stringify({email,password})
            });
    
            const json = await response.json();
    
            if(!response.ok){
                setIsLoading(false);
                setError(json.error);
            }
    
            if(response.ok){
                //save the user to the local storage
                localStorage.setItem('coach',JSON.stringify(json));
                dispatch({type:'COACH_LOGIN',payload:json});
                setIsLoading(false);
                navigate('/coach/dashboard');

            }
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }

        
    }

    return {coachLogin, isLoading, error};
}